<script>
    import { onDestroy, onMount } from 'svelte'
    import { DateTime } from 'luxon'

    export let testerData = []
    export let testers = []
    let animationFrame

    let blinkTimeout = 180

    const uptime = _ => {
        Object.keys(testerData).forEach(robot => {
           Object.values(testerData[robot]).forEach(tester => {
                let time = DateTime.now().diff(DateTime.fromMillis(tester.statusUpdated)).toFormat('mm:ss')
                Object.assign(tester, { time })
            })

        })
        testerData = testerData

        animationFrame = requestAnimationFrame(uptime)
    }
    window.requestAnimationFrame(uptime)

    onDestroy(_ => cancelAnimationFrame(uptime))

    const shouldBlink = (time, status, code) => {
        switch (status) {
            case 'IDLE':
            case 'RUNNING':
            case 'OVERDUE':
                if (DateTime.now().diff(DateTime.fromMillis(time)).toFormat('ss') >= blinkTimeout)
                    return true
                break
            case 'ERRORED':
                return code !== 16;
        }
        return false
    }
    let test = {}
    let loaded = false

</script>

<div class="flex flex-col mx-2 h-[94%]">
	{#if Object.keys(testerData).length}

		{#each Object.keys(testerData) as key}
			{#if key !== 'manual'}
				<div id="grid" class="flex 2xl:h-4/5 mt-4 flex-wrap grid grid-flow-row grid-cols-2 2xl:grid-cols-5 gap-3 2xl:gap-x-3 2xl:gap-y-5">
					{ #each  Object.values(testerData[key]) as { tester, code, message, currentTest, status, statusUpdated, time, timestamp, robot }, index }
						{#if key !== 'manual'}
							<div class="flex flex-col rounded-xl border border-black p-1 shadow-lg
									{ { IDLE: 'idle', ERRORED: 'error', UNKNOWN: 'offline', RUNNING: 'running', OVERDUE: 'overdue' } [status]}"
								 	class:blinkAnimation="{ shouldBlink(statusUpdated, status, code) }">
								<div class="w-full flex flex-col">
									<div class="w-full flex justify-between h-4 text-sm lg:text-base xl:text-lg font-bold text-center px-1">
										<div class="flex flex-row text-center">
											<span> { time }</span>
										</div>
										<span>{robot}</span>
									</div>
									<div class="text-center">
										<span class="font-bold text-base lg:text-2xl xl:text-3xl">{tester}</span>
									</div>
									<div class="text-center truncate lg:whitespace-normal w-full text-xs md:text-sm xl:text-base font-bold">
										{#if status === 'ERRORED'}
											<span>{code} - {message}</span>
										{:else if status === 'UNKNOWN'}
											<span>{message}</span>
										{:else if currentTest !== 'N/A'}
											<span>{currentTest}</span>
										{/if}
									</div>
								</div>
							</div>
						{/if}
					{/each}
				</div>
			{:else }
				<div class="flex 2xl:h-3/5 mt-4 flex-wrap grid grid-flow-row grid-cols-2 gap-4 border-t-2 border-sky-900 ">
					{ #each Object.values(testerData[key]) as { tester, code, message, currentTest, status, statusUpdated, timestamp, time } }
						{#if key === 'manual'}
							<div class="flex flex-col rounded-xl border border-black mt-2 shadow-lg
					 				{ { IDLE: 'idle', ERRORED: 'error', UNKNOWN: 'offline', RUNNING: 'running', OVERDUE: 'overdue' } [status]}"
								 	class:blinkAnimation="{ shouldBlink(statusUpdated, status, code) }">
								<div class="w-full flex flex-col">
									<div class="w-full flex justify-between h-4 text-base font-bold text-center px-1">
										<div class="flex flex-row text-center">
											<span>{time}</span>
										</div>
									</div>
									<div class="text-center">
										<span class="text-md lg:text-3xl font-bold text-xl">{tester}</span>
									</div>
									<div class="text-center truncate lg:whitespace-normal w-full text-xs md:text-sm xl:text-base font-bold">
										{#if status === 'ERRORED'}
											<span>{code} - {message}</span>
										{:else if status === 'UNKNOWN'}
											<span>{message}</span>
										{:else if currentTest !== 'N/A'}
											<span>{currentTest}</span>
										{/if}
									</div>
								</div>
							</div>
						{/if}
					{/each}
				</div>
			{/if}
		{/each}

	{/if}
</div>

<style>
    .blinkAnimation {
        animation: blinker 1s step-start infinite;
    }

    @keyframes blinker {
        50% {
            opacity: 0.8;
            background: linear-gradient(45deg, rgb(212, 212, 212), rgb(212, 212, 212));
        }
    }

</style>
